import { Button, useSnackbar } from '@festo-ui/react';
import { useState } from 'react';
import Overlay from './Overlay';
import useTranslation from '../../../../features/translation/hooks/useTranslation';
import './AddToBasket.scss';
import { econdaClickEvent } from '../../../../Econda';
import { ShockAbsorberSolution } from '../../../../interfaces';
import { useLocation } from 'react-router';
import Login from '../Login/Login';
import { PricingItemResponse } from '../../../../features/pricing/api';

enum TranslationKeys {
  ADD_TO_CART = 'addToCart',
  YOUR_PRICE = 'addToCartYourPrice',
}

interface CartDTO {
  id: number;
  orderCode: string;
  image: {
    altText: string;
    type: string;
    url: string;
  };
  partNumber: string;
}

interface BasketProps {
  product: ShockAbsorberSolution;
  price: PricingItemResponse | null;
}

export default function AddToBasket({ product, price }: BasketProps): JSX.Element {
  const { pathname } = useLocation();
  const t = useTranslation();
  const { addSnackbar } = useSnackbar();

  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);

  function handleClick() {
    econdaClickEvent(pathname, 'primary button', 'add to cart', 'click');
    addToBasket(showSnackbar);
    setIsLoading(true);
    setTimeout(() => setIsLoading(false), 2000);
    setTimeout(() => setOpen(true), 2000);
  }

  async function addToBasket(callback: () => void): Promise<void> {
    const callerId = 'ShockAbsorber';

    const items: CartDTO[] = [
      {
        id: product.id,
        image: product.image,
        orderCode: product.orderCode,
        partNumber: product.partNumber,
      },
    ];

    try {
      const { name } = window;
      const transformedItems = items.map((product) => ({
        qty: 1,
        partNo: product.partNumber,
        IDCode1: product.orderCode,
      }));

      const request = { action: `${name}.addToBasketClicked`, callerId, parts: transformedItems };
      await postMessage(JSON.stringify(request), '*');
    } catch (error) {
      callback();
    }
  }

  function showSnackbar() {
    if (addSnackbar) {
      addSnackbar({
        text: 'Something went wrong',
        showClose: true,
        type: 'warning',
      });
    }
  }

  return (
    <div className="solution--add_to_basket fwe-mb-4">
      <Overlay loading={isLoading} onClose={() => setOpen(false)} open={open} />
      <Login price={price} />
      <Button icon="ecommerce-basket" primary large onClick={handleClick}>
        {t(TranslationKeys.ADD_TO_CART)}
      </Button>
    </div>
  );
}
